import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import environment from '../../environment';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  } else {
    // Save full URL including query params for admin preview feature
    // window.location.href captures the complete URL with all params
    const fullUrl = window.location.href;
    if (environment.settings.verboseLogging) {
      console.log(
        'AuthGuard - Not logged in, saving redirect URL:',
        fullUrl
      );
    }
    localStorage.setItem('loginRedirect', fullUrl);
    router.navigate(['/Login']);
    return false;
  }
};
